module.exports = __webpack_public_path__ + "static/media/ATAgray.95accc43.png";